/**
 * Site-wide schema.org JSON-LD for search engines (Organization, WebSite, Service).
 */
export function buildSiteJsonLd(siteUrl: string): Record<string, unknown> {
  const base = siteUrl.replace(/\/$/, '');
  const orgId = `${base}/#organization`;
  const websiteId = `${base}/#website`;
  const serviceId = `${base}/#service`;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': orgId,
        name: 'Hebern',
        url: `${base}/`,
        logo: `${base}/assets/full-logo-transparent.svg`,
        description:
          'Hebern provides automatic encryption services that integrate into your development workflow, keeping applications fast and secure.',
        email: 'support@hebern.com',
        slogan: 'Quick and easy data encryption, secure from AI.',
      },
      {
        '@type': 'WebSite',
        '@id': websiteId,
        url: `${base}/`,
        name: 'Hebern',
        description:
          'Hebern provides automatic encryption services that integrate into your development workflow, keeping applications fast and secure.',
        publisher: { '@id': orgId },
        inLanguage: 'en-US',
        isPartOf: { '@id': orgId },
      },
      {
        '@type': 'Service',
        '@id': serviceId,
        name: 'Hebern Encryption Platform',
        description:
          'Seamless encryption solutions that integrate into your development workflow. Data is separated from encryption processes and keys.',
        serviceType: 'Application encryption and data security',
        provider: { '@id': orgId },
        areaServed: 'Worldwide',
        audience: {
          '@type': 'Audience',
          audienceType: 'Software developers and organizations',
        },
      },
    ],
  };
}
